var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin === true && !_vm.$store.state.switch_admin_username
            ? _c("masteradmin-sidebar-menu")
            : _vm._e(),
          _vm._v(" "),
          _vm.csr == true ? _c("CSRSidebarMenu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper tasklist-preview" }, [
            _c("div", [
              _c("h3", { staticClass: "d-inline heading" }, [
                _vm._v(_vm._s(_vm.tasklist_title))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "heading-seperator" }),
            _vm._v(" "),
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                {
                  staticClass: "col-md-12 counter_subtask-list",
                  attrs: { id: "tasks" }
                },
                _vm._l(_vm.subtasks, function(subtask, stindex) {
                  return _c("div", [
                    _c(
                      "div",
                      { staticClass: "subtask-wrapper" },
                      [
                        _c(
                          "h4",
                          { staticClass: "panel-title" },
                          [
                            _c(
                              "b-link",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "collapse-" + subtask.id,
                                    expression: "'collapse-' + subtask.id"
                                  }
                                ]
                              },
                              [
                                _c("span", {
                                  staticClass: "counter_subtask-list__counter"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(subtask.name) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            staticClass: "mt-2 subtask-wrapper",
                            attrs: { id: "collapse-" + subtask.id }
                          },
                          [
                            _c("b-card", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_heading-list"
                                },
                                _vm._l(subtask.headings, function(
                                  heading,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value:
                                                "collapse-" +
                                                subtask.id +
                                                "-" +
                                                heading.id,
                                              expression:
                                                "'collapse-' + subtask.id + '-' + heading.id"
                                            }
                                          ],
                                          staticClass: "sub-heading",
                                          attrs: { size: "sm" }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "counter_heading-list__counter"
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(heading.name) +
                                              "\n                    "
                                          ),
                                          _c("i", {
                                            staticClass: "fa fa-angle-down",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          staticClass: "mt-2 task-wrapper",
                                          attrs: {
                                            id:
                                              "collapse-" +
                                              subtask.id +
                                              "-" +
                                              heading.id
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 override-padding counter_task-list"
                                            },
                                            _vm._l(heading.tasks, function(
                                              task
                                            ) {
                                              return _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-card",
                                                    {
                                                      staticClass:
                                                        "hidden-xs hidden-sm"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task-title"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_task-list__counter"
                                                          }),
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                task.description
                                                              ) +
                                                              "\n                          "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_task-list"
                                },
                                _vm._l(subtask.tasks, function(
                                  substasklisttask
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "task-wrapper" },
                                    [
                                      _c(
                                        "b-card",
                                        { staticClass: "hidden-xs hidden-sm" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "task-title" },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "counter_task-list__counter"
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    substasklisttask.description
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e6dbdfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6dbdfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/tasklist_preview.vue
// module id = null
// module chunks = 